import { render } from "./QuizQuestion.vue?vue&type=template&id=07a21698&scoped=true&ts=true"
import script from "./QuizQuestion.vue?vue&type=script&lang=ts"
export * from "./QuizQuestion.vue?vue&type=script&lang=ts"

import "./QuizQuestion.vue?vue&type=style&index=0&id=07a21698&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a21698"]])

export default __exports__